import React from 'react';
import { Button } from "@/components/ui/button";

const selectedSymbolsReport = [
  { symbol: 'BTCUSDT', strategy: 'auto_signal', tf: '1h', return: '+8.81%', sharpe: '+1.99', trades: '3', win: '100.0%' },
  { symbol: 'ETHUSDT', strategy: '제외됨 (no data)', tf: '-', return: '-', sharpe: '-', trades: '-', win: '-' },
  { symbol: 'BNBUSDT', strategy: 'channel_trend2_strategy', tf: '30m', return: '+4.60%', sharpe: '+2.07', trades: '2', win: '100.0%' },
  { symbol: 'SOLUSDT', strategy: 'auto_signal', tf: '15m', return: '+23.07%', sharpe: '+1.10', trades: '14', win: '77.8%' },
  { symbol: 'XRPUSDT', strategy: 'auto_signal', tf: '1h', return: '+8.05%', sharpe: '+1.44', trades: '3', win: '100.0%' },
  { symbol: 'DOGEUSDT', strategy: 'channel_trend2_strategy', tf: '1h', return: '+16.58%', sharpe: '+1.62', trades: '2', win: '100.0%' },
  { symbol: 'TRXUSDT', strategy: '제외됨 (no data)', tf: '-', return: '-', sharpe: '-', trades: '-', win: '-' },
  { symbol: 'LINKUSDT', strategy: 'macd_ema', tf: '1h', return: '+20.45%', sharpe: '+1.82', trades: '28', win: '57.1%' },
  { symbol: 'LTCUSDT', strategy: 'auto_signal', tf: '1h', return: '+4.76%', sharpe: '+0.99', trades: '3', win: '100.0%' },
  { symbol: 'NEARUSDT', strategy: 'auto_signal', tf: '30m', return: '+94.89%', sharpe: '+2.08', trades: '5', win: '66.7%' },
  { symbol: 'ENAUSDT', strategy: 'auto4_mtf_signal', tf: '4h', return: '+13.43%', sharpe: '+4.32', trades: '5', win: '100.0%' },
  { symbol: 'TAOUSDT', strategy: 'auto_signal', tf: '30m', return: '+28.67%', sharpe: '+1.58', trades: '3', win: '100.0%' },
  { symbol: 'TURBOUSDT', strategy: 'channel_trend2_strategy', tf: '30m', return: '+3.38%', sharpe: '+1.39', trades: '2', win: '100.0%' },
  { symbol: 'WLDUSDT', strategy: 'macd_ema', tf: '1h', return: '+94.69%', sharpe: '+3.22', trades: '26', win: '69.2%' },
  { symbol: 'AAVEUSDT', strategy: 'auto4_mtf_signal', tf: '4h', return: '+8.13%', sharpe: '+3.36', trades: '5', win: '100.0%' },
  { symbol: 'SUIUSDT', strategy: 'zerolag_macd', tf: '4h', return: '+24.87%', sharpe: '+2.68', trades: '6', win: '100.0%' },
  { symbol: 'ONDOUSDT', strategy: 'zerolag_macd', tf: '1h', return: '+29.58%', sharpe: '+1.31', trades: '38', win: '31.6%' }
];

interface Props {
  onOpenModal: () => void;
}

export const SignalSidePanelPortfolio: React.FC<Props> = ({ onOpenModal }) => {
  return (
    <div className="space-y-5">
      <div className="space-y-2">
        <div className="flex justify-between items-center px-1">
          <h4 className="text-xs font-black text-primary">📊 심볼별 최적 전략 백테스트 (2026-06-04) [지난30일간]</h4>
        </div>
        <div className="border border-border/60 rounded-xl overflow-hidden">
          <table className="w-full text-left border-collapse text-[10px]">
            <thead>
              <tr className="bg-muted/40 border-b border-border font-bold text-muted-foreground">
                <th className="p-2">심볼</th>
                <th className="p-2">전략</th>
                <th className="p-2 text-center">TF</th>
                <th className="p-2 text-right">수익률(누적)</th>
                <th className="p-2 text-right">Sharpe</th>
                <th className="p-2 text-right">거래수</th>
                <th className="p-2 text-right">승률</th>
              </tr>
            </thead>
            <tbody>
              {selectedSymbolsReport.map((row) => (
                <tr key={row.symbol} className="border-b border-border/40 hover:bg-muted/30">
                  <td className="p-2 font-bold">{row.symbol.replace('USDT', '')}</td>
                  <td className="p-2 text-muted-foreground truncate max-w-[100px]" title={row.strategy}>{row.strategy}</td>
                  <td className="p-2 text-center font-semibold">{row.tf}</td>
                  <td className={`p-2 text-right font-black ${row.return.startsWith('+') ? 'text-success' : 'text-muted-foreground'}`}>{row.return}</td>
                  <td className={`p-2 text-right ${row.sharpe.startsWith('+') ? 'text-success' : 'text-muted-foreground'}`}>{row.sharpe}</td>
                  <td className="p-2 text-right">{row.trades}</td>
                  <td className="p-2 text-right">{row.win}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="text-[9px] text-muted-foreground/80 italic px-1 mb-3">
          ※ 지정된 17종 주요 코인의 batch 백테스트 결과 데이터입니다.
        </p>
      </div>

      <div className="pt-2 border-t border-border/50 flex justify-center">
        <Button
          variant="outline"
          size="sm"
          onClick={onOpenModal}
          className="w-full h-9 text-[11px] font-black rounded-xl border-primary/30 text-primary hover:bg-primary/5 shadow-xs"
        >
          📂 기존 28개 종목 포트폴리오 백테스트 결과 상세
        </Button>
      </div>
    </div>
  );
};
